import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://pos.ai961.com/api';

const debtorsAPI = axios.create({
  baseURL: `${API_BASE_URL}/items/debtors/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
debtorsAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle paginated responses
debtorsAPI.interceptors.response.use((response) => {
  // If response.data has pagination structure, return the results array
  if (response.data && typeof response.data === 'object' && 'results' in response.data) {
    // Keep the pagination info but transform data to be the array
    response.data = response.data.results || [];
  }
  return response;
});

export const debtorsService = {
  // Get all debtors
  getDebtors: (params = {}) => debtorsAPI.get('', { params }),

  // Get single debtor
  getDebtor: (id) => debtorsAPI.get(`${id}/`),

  // Create new debtor
  createDebtor: (data) => debtorsAPI.post('', data),

  // Update debtor
  updateDebtor: (id, data) => debtorsAPI.put(`${id}/`, data),

  // Delete debtor
  deleteDebtor: (id) => debtorsAPI.delete(`${id}/`),

  // Search debtors by name or phone
  searchDebtors: (search) => debtorsAPI.get('', { params: { search } }),

  // Get debtors by status
  getDebtorsByStatus: (status) => debtorsAPI.get('', { params: { status } }),

  // Get overdue debtors
  getOverdueDebtors: () => debtorsAPI.get('overdue/'),

  // Mark debtor as paid
  markAsPaid: (id) => debtorsAPI.post(`${id}/mark_paid/`),

  // Add payment to debtor
  addPayment: (id, amount) => debtorsAPI.post(`${id}/add_payment/`, { amount }),

  // Send WhatsApp message
  sendWhatsApp: (id) => debtorsAPI.post(`${id}/send_whatsapp/`),

  // Get debtor statistics
  getDebtorStats: () => debtorsAPI.get('', { params: { status: 'all' } }),
  
  // Get detailed statistics for a specific debtor
  getDebtorStatistics: (id) => debtorsAPI.get(`${id}/statistics/`),

  // Get printable account statement for a specific debtor
  getDebtorStatement: (id) => debtorsAPI.get(`${id}/statement/`),
};

export default debtorsService;
